import { Component, inject, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { QaroniBaseSubsDirective } from '@qaroni-core/directives/qaroni-base-subs/qaroni-base-subs.directive';
import { filter } from 'rxjs';

@Component({
  standalone: true,
  selector: 'qaroni-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent extends QaroniBaseSubsDirective implements OnInit {
  private router = inject(Router);
  private renderer = inject(Renderer2);

  private routesToHideBadge = [
    new RegExp('^/dashboard/tickets/[^/]+/details$'),
    new RegExp('^/supports/tickets/[^/]+/details$'),
  ];

  private routerEvent$ = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd)
  );

  ngOnInit(): void {
    this.subs.add(this.routerEvent$.subscribe(this.getRouterEvent));
  }

  private getRouterEvent = (event): void => {
    const navEndEvent = event as NavigationEnd;
    const currentUrl = navEndEvent.urlAfterRedirects;

    const hidden = this.routesToHideBadge.some(pattern => {
      if (pattern instanceof RegExp) {
        return pattern.test(currentUrl);
      } else {
        return currentUrl.startsWith(pattern);
      }
    });

    if (hidden) {
      this.renderer.addClass(document.body, 'hide-recaptcha-badge');
    } else {
      this.renderer.removeClass(document.body, 'hide-recaptcha-badge');
    }
  };
}
